import React, { useMemo } from "react";

import { DashboardTabOptionComponentProps } from "api/model/dashboard/Dashboard";
import { Dropdown } from "primereact/dropdown";
import { Menu } from "primereact/menu";
import { T } from "services/lang/LanguageService";
import { ArrowDirection } from "utils/enums";
import "../dashboard-styles/DashboardMain.scss";
import { getMenuItems } from "../utils";
import ArrowNavigationButtons from "./common/ArrowNavigationButtons";
import { useTabGroups } from "./common/useTabGroups";
import useTabNavigation from "./common/useTabNavigation";

const DashboardSubTabsDropdownMenu = ({
  isMobile,
  menuRef,
  tabId,
  dashboard,
}: DashboardTabOptionComponentProps) => {
  const { handleTabChange } = useTabNavigation(dashboard, isMobile);
  const { selectedTabGroupUUID, tabGroups, tabsInGroup, handleTabGroupChange, changeTabWithArrow } =
    useTabGroups(dashboard, tabId, handleTabChange);

  const selectedTabUUID = useMemo(() => {
    return dashboard?.dashboardTabsJs?.[tabId]?.uuid;
  }, [dashboard?.dashboardTabsJs, tabId]);

  return (
    <div>
      {isMobile ? (
        <Menu
          ref={menuRef}
          model={getMenuItems(tabGroups, handleTabChange)}
          popup
          className="w-12 menu-list"
        />
      ) : (
        <div className="flex flex-row gap-2 items-center tabs-dropdown">
          <Dropdown
            value={selectedTabGroupUUID}
            options={tabGroups}
            onChange={handleTabGroupChange}
            className="w-21rem"
            filter
            showFilterClear
            placeholder={T("action.select-group")}
          />
          {dashboard.showTabNavigation && (
            <ArrowNavigationButtons
              isPrevDisabled={tabGroups.findIndex(node => node.value === selectedTabGroupUUID) <= 0}
              isNextDisabled={
                tabGroups.findIndex(node => node.value === selectedTabGroupUUID) === tabGroups.length - 1
              }
              prevTooltip={T("action.select-previous-tab-group")}
              nextTooltip={T("action.select-next-tab-group")}
              onPrev={() => changeTabWithArrow(ArrowDirection.UP, tabGroups, selectedTabGroupUUID!, true)}
              onNext={() => changeTabWithArrow(ArrowDirection.DOWN, tabGroups, selectedTabGroupUUID!, true)}
            />
          )}
          <Dropdown
            value={selectedTabUUID}
            options={tabsInGroup}
            onChange={e => handleTabChange(e.value, e)}
            className="w-21rem"
            filter
            placeholder={T("action.select-group")}
          />
          {dashboard.showTabNavigation && tabsInGroup.length > 1 && (
            <ArrowNavigationButtons
              isPrevDisabled={tabsInGroup.findIndex(node => node.value === selectedTabUUID) <= 0}
              isNextDisabled={
                tabsInGroup.findIndex(node => node.value === selectedTabUUID) === tabsInGroup.length - 1
              }
              prevTooltip={T("action.select-previous-tab")}
              nextTooltip={T("action.select-next-tab")}
              onPrev={() => changeTabWithArrow(ArrowDirection.UP, tabsInGroup, selectedTabUUID!)}
              onNext={() => changeTabWithArrow(ArrowDirection.DOWN, tabsInGroup, selectedTabUUID!)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default DashboardSubTabsDropdownMenu;
